"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeHostDispatcher = exports.HostDispatcher = void 0;
class HostDispatcher {
}
exports.HostDispatcher = HostDispatcher;
function makeHostDispatcher() {
    return new HostDistpatcherImp();
}
exports.makeHostDispatcher = makeHostDispatcher;
class HostDistpatcherImp extends HostDispatcher {
    constructor() {
        super(...arguments);
        this.appHandlerVersion = 0;
        this.appPayloadVersions = new Map();
        this.registerAppHandler = (appHandler) => {
            this.appHandler = appHandler;
            this.getAppHandlerVersion();
        };
        this.setupVersion = (version) => {
            // Apps before app package version 2.27 will not reach this
            this.appHandlerVersion = version;
            this.getPayloadVersions();
        };
        this.setupPayloadVersions = (payloadVersion) => {
            this.appPayloadVersions = payloadVersion;
        };
        this.dispatch = (request) => {
            if (!this.appHandler) {
                console.error('[HostDispatcher] No app handler has been registered');
                return;
            }
            this.appHandler(request);
        };
        this.showBabylonInspector = (show) => {
            var _a;
            const type = 'SHOW_BABYLON_INSPECTOR';
            const version = (_a = this.appPayloadVersions.get(type)) !== null && _a !== void 0 ? _a : 1;
            const payload = {
                showBabylonInspector: show,
            };
            this.doDispatch(type, version, payload);
        };
        this.setIsAuthoring = (isAuthoring) => {
            var _a;
            const type = 'SET_IS_AUTHORING';
            const version = (_a = this.appPayloadVersions.get(type)) !== null && _a !== void 0 ? _a : 1;
            const payload = { isAuthoring };
            this.doDispatch(type, version, payload);
        };
        this.disposeApp = () => {
            var _a;
            const type = 'DISPOSE_APP';
            const version = (_a = this.appPayloadVersions.get(type)) !== null && _a !== void 0 ? _a : 1;
            this.doDispatch(type, version);
        };
        this.stopApp = () => {
            var _a;
            const type = 'STOP_APP';
            const version = (_a = this.appPayloadVersions.get(type)) !== null && _a !== void 0 ? _a : 1;
            this.doDispatch(type, version);
        };
        this.startApp = (container) => {
            var _a;
            const type = 'START_APP';
            const version = (_a = this.appPayloadVersions.get(type)) !== null && _a !== void 0 ? _a : 2;
            const payload = {
                container,
            };
            this.doDispatch(type, version, payload);
        };
        this.setState = (finalState, duration) => {
            var _a;
            const type = 'SET_APP_STATE';
            const version = (_a = this.appPayloadVersions.get(type)) !== null && _a !== void 0 ? _a : 2;
            const payload = {
                finalState,
                duration,
            };
            this.doDispatch(type, version, payload);
        };
        this.setDevicePreview = (x, y) => {
            var _a;
            const type = 'SET_DEVICE_PREVIEW';
            const version = (_a = this.appPayloadVersions.get(type)) !== null && _a !== void 0 ? _a : 1;
            const request = {
                type,
                version,
                payload: {
                    x,
                    y,
                },
            };
            this.dispatch(request);
        };
        this.startZSpace = (device, session) => {
            var _a;
            const type = 'START_ZSPACE';
            const version = (_a = this.appPayloadVersions.get(type)) !== null && _a !== void 0 ? _a : 1;
            const request = {
                type,
                version,
                payload: {
                    device,
                    session,
                },
            };
            this.dispatch(request);
        };
        this.stopZSpace = () => {
            var _a;
            const type = 'STOP_ZSPACE';
            const version = (_a = this.appPayloadVersions.get(type)) !== null && _a !== void 0 ? _a : 1;
            const request = {
                type,
                version,
            };
            this.dispatch(request);
        };
    }
    getAppHandlerVersion() {
        const type = 'GET_APP_HANDLER_VERSION';
        const payload = { callback: this.setupVersion };
        try {
            this.doDispatch(type, 1, payload);
        }
        catch (_a) {
            // All good. this is probably an older app
        }
    }
    getPayloadVersions() {
        const type = 'GET_APP_PAYLOAD_VERSION';
        const payload = { callback: this.setupPayloadVersions };
        this.doDispatch(type, 2, payload);
    }
    doDispatch(type, version, payload) {
        const request = {
            type,
            version,
            payload,
        };
        this.dispatch(request);
    }
}
